/**
 * Dr. Mani's Magic Quiz — answer option emoji.
 *
 * Keyed by the option's existing `icon` value so questions.ts stays a faithful
 * copy of dr-mm-files/dmm-quiz-spec.json. The keys are 1:1 with answer options,
 * so this map doubles as the per-option emoji list.
 *
 * Matches the USCN quiz, which stores an emoji per option and renders it above
 * the label. The same emoji may repeat across different questions.
 */

/** Shown when an option has no icon key, or a key that is not mapped here. */
export const DMM_FALLBACK_EMOJI = '🌱';

export const DMM_ICON_EMOJI: Record<string, string> = {
  // Q1: Where do you grow
  building_balcony: '🏢',
  house_grass: '🏡',
  house_potted: '🪴',
  barn_fence: '🚜',

  // Q2: What do you grow
  tomato_vine: '🍅',
  herb_sprig: '🌿',
  open_bloom: '🌸',
  plant_pot: '🪴',
  fruit_tree: '🍊',
  grape_cluster: '🍇',
  simple_tree: '🌳',
  cactus_pot: '🌵',
  butterfly_flower: '🦋',
  seedling: '🌱',
  grass_blades: '🌾',

  // Q3: How do you garden
  trowel_soil: '🌱',
  raised_bed: '🪵',
  two_pots: '🪴',
  windowsill_pot: '🪟',
  greenhouse: '🏡',

  // Q4: Lawn size, small to large
  grass_patch_1: '🌱',
  grass_patch_2: '🌿',
  grass_patch_3: '🌾',
  grass_patch_4: '🍀',
  grass_patch_5: '🌳',

  // Q5: How much are you growing
  one_pot: '🪴',
  three_pots: '🌿',
  house_garden_rows: '🏡',
  barn_rows_tree: '🚜',

  // Q6: Why you grow
  harvest_basket: '🧺',
  flower_vase: '💐',
  thumb_leaf: '👍',
  leaf_still_water: '🧘',
  leaf_shield: '🛡️',

  // Q7: Struggles
  droplet_root: '💧',
  drooping_leaf: '🥀',
  closed_bud: '🌰',
  wilted_pot: '🍂',
  beetle: '🐛',
  smell_bag: '🤢',
  no_chemicals: '🚫',
  cracked_soil: '🏜️',
  book_leaf: '📖',
  grass_bare_ring: '🟫',

  // Q8: Experience, seed to tree
  growth_1: '🌱',
  growth_2: '🌿',
  growth_3: '🪴',
  growth_4: '🌳',

  // Q9: What it will mean
  mountain_flag: '🏔️',
  house_vine: '🏡',
  basket_out: '🧺',
  hand_sprout: '🤲',
  plate_leaf: '🍽️',
};

/** Resolve an option's emoji, falling back to the seedling for unmapped keys. */
export function dmmOptionEmoji(iconKey?: string): string {
  if (!iconKey) return DMM_FALLBACK_EMOJI;
  return DMM_ICON_EMOJI[iconKey] || DMM_FALLBACK_EMOJI;
}
